export default "__VITE_ASSET__49a91745__"